import { SidebarProvider } from '@/components/ui/sidebar'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_settings')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <SidebarProvider
      key="settings-sidebar-provider"
      name="settings-sidebar"
      open={true}
    >
      <Outlet />
    </SidebarProvider>
  )
}
